import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { Subscription } from 'rxjs';
import { AutenticacaoService } from './seguranca/autenticacao.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  isCasasBahia =
    location.href.indexOf("casasbahia") > 0 || location.href.indexOf("-cb") > 0;

  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    private autenticacaoService: AutenticacaoService,
  ) { }

  ngOnInit(): void {
    this.autenticacaoService.identificarBandeira();
    this.subscriptions.add(
      this.googleAnalyticsService.listenUTMParamsAndUpdateUrl()
    );

    this.loadInsiderScript()
      .then(() => {
        console.log('Insider Tag carregada.');
       this.router.events.subscribe((event) => {
         if (event instanceof NavigationEnd) {
           this.reinitializeInsiderTag();
         }
       });
      }).catch((err) => console.error('Erro ao carregar Insider Tag.', err));
  }

  loadInsiderScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (typeof window['Insider'] !== 'undefined') {
        resolve();
      } else {
        const script = document.createElement('script');
        script.src = this.isCasasBahia
          ? "//casasbahiacdc.api.useinsider.com/ins.js?id=10011033"
          : "//pontofriocdc.api.useinsider.com/ins.js?id=10011034";
        script.onload = () => resolve();
        script.onerror = (err) => reject(err);
        document.head.appendChild(script);
      }
    });
  };

  reinitializeInsiderTag(): void {
    if (typeof window['Insider'] !== 'undefined') {
      window['Insider'].eventManager.dispatch('init-manager:re-initialize');
      console.log('Insider Tag re-inicializada.', window['Insider']);
    } else {
      console.warn('Insider Tag ainda não foi carregado.');
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
